import React, { useState } from 'react';
import Footer from '../components/Footer';
import { Mail, Phone, Clock3, MapPin, MessageCircle, Send, CheckCircle2 } from 'lucide-react';
import { supabase } from '../supabase';

export default function ContactPage({ navigate }) {
  const [form, setForm] = useState({ name:'', email:'', subject:'', message:'' });
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const set = k => e => { setError(''); setForm(f=>({...f,[k]:e.target.value})); };

  const handleSend = async () => {
    setError('');
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setError('Please fill in your name, email, and message.');
      return;
    }
    setSaving(true);
    try {
      const { error: err } = await supabase.from('contact_messages').insert({
        name:    form.name.trim(),
        email:   form.email.trim(),
        subject: form.subject.trim() || 'General Enquiry',
        message: form.message.trim(),
      });
      if (err) throw err;
      setDone(true);
      setForm({ name:'', email:'', subject:'', message:'' });
    } catch(e) {
      setError(`Could not send message: ${e.message}. Please reach us on WhatsApp instead.`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="page-hero">
        <div className="section-label">Get in Touch</div>
        <h1>Contact Us</h1>
        <p>We're available 24/7 to help you succeed</p>
      </div>
      <section className="contact-section">
        <div className="contact-grid">
          <div className="contact-info">
            <h3>Let's Talk</h3>
            <p>Get in touch with our team via any channel. We typically respond within minutes during business hours and within 1 hour at other times.</p>
            {[
              { Icon: Mail,   title: 'Primary Email',    val: 'info@arkexpertresearch.com' },
              { Icon: Mail,   title: 'Support Email',    val: 'hello@arkexpertresearch.com' },
              { Icon: Phone,  title: 'Phone / WhatsApp', val: '+1 (618) 815-6526' },
              { Icon: Clock3, title: 'Availability',     val: '24 hours, 7 days a week' },
              { Icon: MapPin, title: 'Markets Served',   val: 'Asia · Middle East · USA · Canada · Australia' },
            ].map(({ Icon, title, val }) => (
              <div className="c-item" key={title}>
                <div className="c-icon"><Icon size={20} /></div>
                <div className="c-text"><h5>{title}</h5><p>{val}</p></div>
              </div>
            ))}
            <button className="wa-btn" onClick={() => window.open('https://wa.me/16188156526','_blank')}>
              <MessageCircle size={20} /> Chat with Us on WhatsApp
            </button>
          </div>

          <div className="contact-form">
            <h3>Send Us a Message</h3>
            {done ? (
              <div style={{textAlign:'center',padding:'40px 20px'}}>
                <CheckCircle2 size={52} color="#16a34a" style={{marginBottom:16}}/>
                <h4 style={{fontFamily:'Sora,sans-serif',fontWeight:700,marginBottom:8}}>Message Sent!</h4>
                <p style={{color:'var(--text-muted)',fontSize:14,marginBottom:20}}>We've received your message and will get back to you as soon as possible.</p>
                <button className="btn-primary" onClick={() => setDone(false)}>Send Another</button>
              </div>
            ) : (
              <>
                {['Your Name','Email','Subject'].map(lbl => (
                  <div className="form-group" key={lbl}>
                    <label>{lbl}{lbl!=='Subject'?' *':''}</label>
                    <input
                      type={lbl==='Email'?'email':'text'}
                      placeholder={lbl==='Your Name'?'Full name':lbl==='Email'?'your@email.com':'How can we help?'}
                      value={form[lbl.toLowerCase().replace(' name','name').replace('your ','')]}
                      onChange={set(lbl==='Your Name'?'name':lbl==='Email'?'email':lbl.toLowerCase())}
                    />
                  </div>
                ))}
                <div className="form-group">
                  <label>Message *</label>
                  <textarea
                    placeholder="Tell us about your assignment or ask us anything..."
                    value={form.message}
                    onChange={set('message')}
                  />
                </div>
                {error && <div style={{background:'rgba(220,38,38,0.08)',border:'1px solid rgba(220,38,38,0.2)',borderRadius:8,padding:'10px 14px',color:'#DC2626',fontSize:13,marginBottom:12}}>{error}</div>}
                <button
                  className="btn-primary"
                  style={{ width:'100%', justifyContent:'center', padding:'14px', opacity:saving?0.7:1 }}
                  onClick={handleSend}
                  disabled={saving}>
                  <Send size={17} /> {saving ? 'Sending…' : 'Send Message'}
                </button>
              </>
            )}
          </div>
        </div>
      </section>
      <Footer navigate={navigate} />
    </div>
  );
}
